module.exports = __webpack_public_path__ + "static/media/Maqro1.eec91a84.png";